export const BASE_URL = process.env['REACT_APP_STRAPI']
// Image file sizes
export const maxFileSize: number = 40 * 1024 * 1024 // 30 MegaBytes
export const fileSizeIntervalHigh: number = 10 * 1024 * 1024 // 20 MegaBytes
export const fileSizeIntervalLow: number = 1 * 1024 * 1024 // 10 MegaBytes
export const targetFileSize: number = 1 * 1024 * 1024 // 8 MegaBytes
